module.exports = __webpack_public_path__ + "static/media/bookr.570415b4.png";